module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#526193",
      "color": "white",
      "padding": "40px 0px",
      "text-align": "center",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticClass: "bottom-cate"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product')))]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('1')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_1')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('2')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading3"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('3')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_3')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading7"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('4')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_4')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [_vm._v("Copyright @ 2022  ADA CHEMICALS")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('contact_addr_2')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fd4cdf7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom.vue
// module id = 1391
// module chunks = 1